import _ from 'lodash';
import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import { lsErrorService, lsHeadersService } from '..';
import { lsImageHelpers } from '../../helpers';

// eslint-disable-next-line import/prefer-default-export
export const lsApiService = {
    request({
        route,
        baseUrl = process.env.VUE_APP_API_BASE_URL,
        apiVersion = 'v1',
        method = 'GET',
        params = {},
        payload = {},
    }) {
        const queryParams = this.generateQueryParams({ params });
        const headers = lsHeadersService.getHeaders();

        const request = {
            url: `${baseUrl}/${apiVersion}${route}${queryParams}`,
            method,
            headers,
            data: payload,
        };

        // if (payload instanceof FormData) {
        //     _.assign(headers, { 'Content-Type': 'multipart/form-data;' });
        // }

        return axios
            .request(request)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => {
                let errorData = null;
                if (_.get(error, 'response.data.error')) {
                    // The request was made but server responded with non 2xx code
                    errorData = error.response.data.error;
                    lsErrorService.log({
                        level: 'warning',
                        message: errorData.message,
                        extra: {
                            error: errorData,
                            request,
                        },
                    });
                } else {
                    // user friendly error message, if we are in this block it would be producing
                    // cryptic error messages to the user
                    errorData = {
                        message: 'There was a network error, please refresh and try again',
                    };
                    // A non response error happened
                    lsErrorService.log({
                        message: error.message || errorData.message,
                        extra: {
                            error,
                            request,
                        },
                    });
                }

                return Promise.reject(errorData);
            });
    },

    generateQueryParams({ params }) {
        return _.reduce(
            params,
            (result, val, key) => {
                let encodedKeyValue = '';
                if (key === 'include') {
                    const encodedArrayString = _.map(val, (value) => {
                        return encodeURIComponent(value);
                    }).join(',');
                    encodedKeyValue = `${encodeURIComponent(key)}=${encodedArrayString}`;
                } else {
                    encodedKeyValue = `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
                }

                const dividerSymbol = result ? '&' : '?';

                return `${result}${dividerSymbol}${encodedKeyValue}`;
            },
            ''
        );
    },

    formatImagesForFormData({ tag, images }) {
        const imagesWithMeta = lsImageHelpers.generateImagesWithMetaPayload({
            images,
            tag,
            // startCase can take an array of strings so no need to join
            namePrefix: _.startCase(_.split(tag, '.')),
        });

        return _.reduce(
            imagesWithMeta,
            (result, { image, meta }) => {
                result.images.push(image);
                result.images_meta.push(meta);
                return result;
            },
            { images: [], images_meta: [] }
        );
    },

    formatFormDataPayload({ payload, parentKey = '', fData = new FormData() }) {
        if (_.isNil(payload)) {
            // don't append nil data keys at all to form data, as it stringifies it
            return fData;
        }

        if (_.isBoolean(payload)) {
            const formDataBool = payload ? 1 : 0;
            fData.append(parentKey, formDataBool);

            return fData;
        }

        if (!_.isObject(payload) && !_.isArray(payload)) {
            // if it's a non iterable, and non boolean, append data
            fData.append(parentKey, payload);
            return fData;
        }

        if (payload.type && payload.name) {
            // if it's an image object, append payload directly
            fData.append(parentKey, payload);
            return fData;
        }

        _.forEach(payload, (val, key) => {
            const baseKey = parentKey ? `${parentKey}[${key}]` : key;
            this.formatFormDataPayload({ payload: val, parentKey: baseKey, fData });
        });

        return fData;
    },
};
